import { GridColDef, GridRowsProp } from '@mui/x-data-grid';
import { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../../app-context';
import IGridComponent from '../../../components/grid/i-grid.component';
import TitlePanel from '../../../components/title-panel/title-panel.component';
import { ALL, DISPOSAL_ACCOUNT, GENERAL_ACCOUNT, GET_STOCK_INPUT, GET_STOCK_ORDER, PAGE_SIZE, PL_ACCOUNT, SAMPLING_ACCOUNT} from '../../common/constants';
import { formatDateLong, formatTo0Decimal, isEmpty, isEmptyArray, isNotEmpty } from '../../common/util.services';
import { getNegativeLedger, searchStockLedger } from '../order.services';
import {getAllSuppliers} from '../../supplier/supplier.services';
import SearchPanel from '../../../components/search-panel/search-panel.component';
import { Grid, IconButton, Stack, Tooltip } from '@mui/material';
import IDropdown from '../../../components/text-component/dropdown/i-dropdown.component';
import './stock.component.scss';
import { useLocation } from 'react-router-dom';
import { getMasterDataById } from '../../master-data/masterdata.services';
import IDialogComponent from '../../../components/dialog/i-dialog.component';
import SpecsComponent from '../../master-data/specs/specs.component';
import IAutoComplete from '../../../components/text-component/auto-complete/i-auto-complete.component';
import AllLedger from './all-ledger.component';
import { HelpOutline } from '@mui/icons-material';
import { getEnquiryProduct } from '../../enquiry/enquiry.services';
import ProductDetailComponent from '../../enquiry/enq-product/product-detail.component';

const StockLedger = () => {
  const appContext = useContext(AppContext);
  const rows: GridRowsProp = [];
  const [stockData, setStockData] = useState(rows);
  const {state} = useLocation();
  const popperProps = {sx: {'.MuiTooltip-tooltip': {bgcolor: 'ivory', fontSize: 16, color: 'black', border: 1}}};
  const [openPrdDetail, setOpenPrdDetail] = useState(false);
  const [prdDetail, setPrdDetail] = useState(null);
  const {orderCode, inputCode, location} = state || {};
  const [searchData, setSearchData] = useState<any>({location: isEmpty(location) ? ALL : location,
                                                     orderCode: isEmpty(orderCode) ? ALL : orderCode,
                                                     itemCode: isEmpty(inputCode) ? ALL : inputCode});
  const [specsData, setSpecsData] = useState(null);
  const [openSpecs, setOpenSpecs] = useState(false);
  const [openAllLedger, setOpenAllLedger] = useState(false);
  const [locationList, setLocationList] = useState<any>([]);
  const [negativeList, setNegativeList] = useState<any>([]);
  const columns: GridColDef[] = [
    { field: 'inputCode', headerName: 'Item Code', filterable: false, sortable: false, editable: false, width: 85,
      cellClassName: (params) => { return getClassName(params)},
      renderCell: (params) => { return <div className="cell-link" title={params.row.inputDesc}
      onClick={() => {openSpecsPopup(params.row.inputId)}}>{params.row.inputCode}</div> }
    },
    { field: 'orderCode', headerName: 'Order Code', filterable: false, sortable: false, editable: false, width: 125,
      cellClassName: (params) => { return getClassName(params)}
    },
    { field: 'product', headerName: 'Product', filterable: false, sortable: false, editable: false, width: 125,
      cellClassName: (params) => { return getClassName(params)},
      renderCell: (params) => (<Stack direction="row" alignItems="center" gap={0}>
                                <IconButton size="small" onClick={() => openPrdDetailPage(params.row.productId)}
                                  sx={{ p: 0.6, ml: -1 }}> <HelpOutline fontSize="small" color='secondary'/>
                                </IconButton>
                                <Tooltip title={params.row.prdDesc} PopperProps={popperProps}>
                                  <span>{params.row.product}</span>
                                </Tooltip></Stack>)
    },
    { field: 'challanType', headerName: 'Type', filterable: false, sortable: false, editable: false, width: 125,
      cellClassName: (params) => { return getClassName(params)}
    },
    { field: 'nextProcess', headerName: 'Process', filterable: false, sortable: false, editable: false, width: 90,
      cellClassName: (params) => { return getClassName(params)}
    },
    { field: 'location', headerName: 'Location', filterable: false, sortable: false, editable: false, width: 150,
      cellClassName: (params) => { return getClassName(params)}
    },
    { field: 'quantity', headerName: 'Quantity', filterable: false, sortable: false, editable: false, width: 110,
      renderCell: (params) => {return formatTo0Decimal(params.row.quantity) + ' ' + params.row.inputUom},
      //cellClassName: (params) => { return getClassName(params)}
      cellClassName: (params) => { return params.row.quantity > 0 ? 'positive' : 'negative' }
    },
    { field: 'balanceQty', headerName: 'Balance', filterable: false, sortable: false, editable: false, width: 110,
      renderCell: (params) => {return formatTo0Decimal(params.row.balanceQty) + ' ' + params.row.inputUom},
      cellClassName: (params) => { return getClassName(params)}
      //cellClassName: (params) => { return Math.round(params.row.balanceQty) < 0 ? 'AdDiffN' : '' }
    },
    { 
      field: 'materialCost', headerName: 'Value', filterable: false, sortable: false, editable: false, width: 110,
      valueFormatter: (materialCost: any) => '₹ ' + formatTo0Decimal(materialCost),
      //cellClassName: (params) => { return getClassName(params)}
      cellClassName: (params) => { return params.row.materialCost > 0 ? 'positive' : 'negative' }
    },
    { field: 'balanceValue', headerName: 'Balance', filterable: false, sortable: false, editable: false, width: 110,
      valueFormatter: (balanceValue: any) => '₹ ' + formatTo0Decimal(balanceValue),
      cellClassName: (params) => { return getClassName(params)}
    },
    { field: 'challanCode', headerName: 'Challan', filterable: false, sortable: false, editable: false, width: 130,
      cellClassName: (params) => { return getClassName(params)}
    },
    { field: 'challanDate', headerName: 'Challan Date', filterable: false, sortable: false, editable: false, width: 180,
      valueFormatter: (challanDate: any) => formatDateLong(challanDate),
      cellClassName: (params) => { return getClassName(params)}
    }
  ];
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [originalPage, setOriginalPage] = useState(0);
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const [totalRows, setTotalRows] = useState(0);

  useEffect(() => {
    getAllSuppliers(appContext,
      (response: any) => {
        let location = [ALL, DISPOSAL_ACCOUNT, GENERAL_ACCOUNT, SAMPLING_ACCOUNT, PL_ACCOUNT, ...response.data];
        setLocationList(location);
        appContext.setShowLoader(false);
        setLoading(false);
      }, (error: any) => {
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message);
        setLoading(false);
      });
  },[])

  useEffect(() => {
    getNegativeLedger(appContext,
      (response: any) => {
        setNegativeList(response.data);
        appContext.setShowLoader(false);
        setLoading(false);
      }, (error: any) => {
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message);
        setLoading(false);
      });
  },[])

  function getClassName(params: any) {
    if('balanceQty' === params.field && params.row.balanceQty < -0.01) {
      return 'ledgerNegative';
    } else if(0 === params.row.ledgerId) {
      return 'ledger1';
    } else {
      return 'ledger2';
    }
  }

  const openPrdDetailPage = (prdId: string) => {
    getEnquiryProduct(prdId, appContext,
      (response: any) => {
        appContext.setShowLoader(false);
        setPrdDetail(response.data);
        setOpenPrdDetail(true);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message);
      });
  }

  useEffect(() => {
    if (isEmptyArray(rows) && isNotEmpty(searchData.itemCode)) {
      searchStockLedger(searchData, page, pageSize, appContext,
        (response: any) => {
          setStockData(response.data.data);
          setTotalRows(response.data.totalElements);
          appContext.setShowLoader(false);
          setLoading(false);
        }, (error: any) => {
          appContext.setShowLoader(false);
          appContext.setErrorMessage(error.message);
          setLoading(false);
        });
    }
  }, [searchData, page, pageSize]);

  const search = (data: any) => {
    if(isNotEmpty(data.negative)) {
      setPage(data.negative);
    } else {
      setPage(originalPage);
    }
    setSearchData(data);
  }

  const closeSpecs = () => {
    setOpenSpecs(false);
  }

  const closeAllLedger = () => {
    setOpenAllLedger(false);
  }

  const openAllLedgerScreen = () => {
    setOpenAllLedger(true);
  }
  
  const closePrdDetail = () => {
    setOpenPrdDetail(false);
  }
  
  const openSpecsPopup = (inputId: any) => {
    setLoading(true);
    getMasterDataById(inputId, appContext,
      (response: any) => {
        appContext.setShowLoader(false);
        setLoading(false);
        setSpecsData(response.data);
        setOpenSpecs(true);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        appContext.setErrorMessage(error.message);
        setLoading(false);
      });
  };

  const onPaginationModelChange = (evt: any) => {
    setPage(evt.page);
    setOriginalPage(evt.page);
    setPageSize(evt.pageSize);
  }

  const getSearchComponent = () => {
    return <SearchPanel search={search} formData={searchData}>
      <Grid container spacing={1}>
        <Grid xs={3}>
          <IAutoComplete name='orderCode' label='Order Code' required={true} url={GET_STOCK_ORDER}/>
        </Grid>
        <Grid xs={3}>
          <IAutoComplete name='itemCode' label='Item Code' required={true} url={GET_STOCK_INPUT}/>
        </Grid>
        <Grid xs={3}>
          <IDropdown name='location' label='Location' required={true}
            itemList={locationList} allItemRequired={false} />
        </Grid>
        <Grid xs={3}>
          <IDropdown name='negative' label='Negative Quantity Page' required={false} itemList={negativeList} />
        </Grid>
      </Grid>
      </SearchPanel>
  }

  const getMainPanel = () => {
    return <>
      {getSearchComponent()}
      <IGridComponent title={''} rows={stockData} columns={columns} loading={loading} hideFooter={isNotEmpty(searchData.negative)}
        paginationType="server" paginationModelChange={onPaginationModelChange} totalRows={totalRows} disableRowSelectionOnClick={true}
        showAddBtn={false} showApproveAction={false} showDeleteAction={false} showUpAction={false} showDownAction={false}
        getRowId={(row: any) => row.id} showExtBtn={false} extBtnText={'All Inputs'} extBtnAction={openAllLedgerScreen} maxHeight={450} />
      <IDialogComponent onClose={closeSpecs} open={openSpecs} title='Specifications' dialogClass={'spec-panel'} 
        dialogBody={<SpecsComponent data={specsData} />} />
      <IDialogComponent onClose={closeAllLedger} open={openAllLedger} title='All Input Ledger' 
        dialogBody={<AllLedger />} />
      <IDialogComponent onClose={closePrdDetail} open={openPrdDetail} title={'Product Details'}
        dialogBody={<ProductDetailComponent readOnly={true} data={prdDetail} close={closePrdDetail}/>} />
    </>
  }

  return <TitlePanel title='Stock Ledger' panelBody={getMainPanel()} />
}

export default StockLedger;